const INFO = {
	main: {
		title: "Dhananjay",
		name: "Dhananjay",
		email: "mail@dhananjaythap111@.gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/ThapAnshu",
		github: "https://github.com/djthap",
		linkedin: "https://www.linkedin.com/in/dhananjay-thap-7a83831b9/",
		instagram: "https://www.instagram.com/djthap/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://www.facebook.com/anshu.thap.7",
	},

	homepage: {

		title: "Full-stack web and mobile app developer.",
		description:
			"I am a Full Stack developer with expertise in MERN. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I’m Dhananjay. I am from  India, where I started my journey to build my future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Biteburst",
			description:
				"I am working on ecommerse website in MERN Stack which will be capable of ordering food  in any language without any adds",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://ecommerce-frontend-amber-two.vercel.app/",
		},
		{
			title: "Amaterasu",
			description:
				"I am working on anime website in MERN Stack which will be capable of watching animes in any language without any adds",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://amaterasuanime.vercel.app/",
		},

		{
			title: "Easy Hai Online ",
			description:
				"I am working on LMS (Learning Management System) in MERN Stack which will be able to handle",
			logo: "eho.png",
			linkText: "View Project",
			link: "https://www.easyhaionline.com/",
		},

		{
			title: "AK Diagnostic lab ",
			description:
				"Built a MERN based E- commerce website of Laboratory which helps in booking Appointment and creating Blogs.",
			logo: "ak.png",
			linkText: "View Project",
			link: "https://www.akdiagnosticslab.com/",
		},

		{
			title: "Healo ",
			description:
				"Built a MERN based E-commerce website on Medicines to sell their products and Creating Blogs.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "- https://www.healo.co/",
		}
	],
};

export default INFO;
